export type SeparatorProps = {
  w?: string;
  h?: string;
  className?: string;
  "data-test"?: string;
};

export function Separator({
  h = "1px",
  w = "100%",
  className = "bg-border",
  "data-test": dataTest,
}: SeparatorProps) {
  return (
    <div
      className={className}
      style={{ height: h, width: w }}
      data-test={dataTest}
    />
  );
}
